export default {"src":"/_next/static/media/0x931715fee2d06333043d11f658c8ce934ac61d0c.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};